import { AxiosInstance, AxiosResponse } from 'axios';
import { ReferralCodeResponse } from '../../types';

export class ReferralApi {
  constructor(private readonly http: AxiosInstance) {}

  async getMyCode(): Promise<ReferralCodeResponse> {
    const response: AxiosResponse<ReferralCodeResponse> = await this.http.get('/referrals/me/code');
    return response.data;
  }

  async createMyCode(): Promise<ReferralCodeResponse> {
    const response: AxiosResponse<ReferralCodeResponse> = await this.http.put('/referrals/me/code');
    return response.data;
  }
}
